import { CancelOutlined, InfoOutlined, SvgIconComponent } from '@mui/icons-material';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export enum ToastType {
    MESSAGE = 'message',
    ALERT = 'alert',
}

const TOAST_CLASSNAMES = {
    [ToastType.MESSAGE]: 'newToast-message',
    [ToastType.ALERT]: 'newToast-alert',
};

export type ToastOptions = {
    hideIcon?: boolean;
    hideCloseButton?: boolean;
    autoClose?: number | false;
    deduplicate?: boolean;
    icon?: SvgIconComponent;
};

const genericToast = (
    toastType: ToastType = ToastType.MESSAGE,
    message?: string,
    options: ToastOptions = {},
) => {
    const IconComponent = options.icon ?? InfoOutlined;
    toast(message, {
        closeButton: !options.hideCloseButton,
        autoClose: options.autoClose ?? 3000,
        data: {
            toastType,
            message,
        },
        icon: options.hideIcon ? false : <IconComponent sx={{ height: 20, width: 20 }} />,
        className: [TOAST_CLASSNAMES[toastType], 'newToast'].join(' '),
        ...(options.deduplicate !== false && { toastId: [toastType, message].join(',') }),
    });
};

export const useToast = () => {
    const showMessage = useCallback((message: string, options?: ToastOptions) => {
        genericToast(ToastType.MESSAGE, message, {
            ...options,
            icon: options?.icon ?? InfoOutlined,
        });
    }, []);

    const showAlert = useCallback((message: string, options?: ToastOptions) => {
        genericToast(ToastType.ALERT, message, {
            ...options,
            icon: options?.icon ?? CancelOutlined,
        });
    }, []);

    return {
        showMessage,
        showAlert,
    };
};
